import { render, staticRenderFns } from "./payType_view.vue?vue&type=template&id=1746976a&scoped=true&"
import script from "./payType_view.vue?vue&type=script&lang=js&"
export * from "./payType_view.vue?vue&type=script&lang=js&"
import style0 from "./payType_view.vue?vue&type=style&index=0&id=1746976a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1746976a",
  null
  
)

export default component.exports